import { render, staticRenderFns } from "./PlacesListPage.vue?vue&type=template&id=72f63094&"
import script from "./PlacesListPage.vue?vue&type=script&lang=js&"
export * from "./PlacesListPage.vue?vue&type=script&lang=js&"
import style0 from "./PlacesListPage.vue?vue&type=style&index=0&id=72f63094&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports